module.exports = __webpack_public_path__ + "img/popcat.4158e1f3.svg";